import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import LineCallback from "@/views/LineCallback.vue";
import ConfigServiceScreen from "@/views/ConfigServiceScreen.vue";
import DmeApproveScreen from "@/views/dme/DmeApproveScreen.vue";
import useState from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/lineCallback",
    name: "LineCallback",
    component: LineCallback,
  },
  {
    path: "/configService",
    name: "ConfigService",
    component: ConfigServiceScreen,
  },
  {
    path: "/dmeApprove",
    name: "dmeApprove",
    component: DmeApproveScreen,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const state = useState();
const whitelist = ["dmeApprove"];
router.beforeEach((to, _) => {
  if (typeof to.name == "string" && whitelist.indexOf(to.name) >= 0) {
    return true;
  }
  if (!state.value.token && to.name !== "Login") {
    return router.push({ name: "Login", params: to.params, query: to.query });
  } else if (state.value.token && to.name === "Login") {
    return "/";
  }
  return true;
});

export default router;
